import QuranProgramsModel from '../Apis/QuranPrograms'
import Controller from './Controller'

export default class QuranProgramsController extends Controller {
  constructor() {
    super(new QuranProgramsModel())
  }

  async MakeSupervisor(params) {
    const res = await this.model.MakeSupervisor(params);
    return this.Poup(res);
  }
  //AssignTeacher.
  async AssignTeacher(id, params) {
    const res = await this.model.AssignTeacher(id, params);
    return this.Poup(res);
  }
  async Addschedule(params) {
    const res = await this.model.Addschedule(params);
    return this.Poup(res);
  }
  // 
  async StudentAssign(params) {
    const res = await this.model.StudentAssign(params);
    return this.Poup(res);
  }
  async Join(params) {
    const res = await this.model.Join(params);
    return this.Poup(res);
  }
  async MyProgram(params) {
    const data = await this.model.MyProgram(params)
    return data
  }
  async ProgramTeacher(params) {
    const data = await this.model.ProgramTeacher(params)
    return data
  }
  async ArchiveStudent(studentId) {
    const res = await this.model.ArchiveStudent(studentId);
    return this.Poup(res);
  }
  static ReadingType() {
    return new QuranProgramsModel().ReadingType()
  }
}
